const commonValues = {
  name: '',
  phone: '',
  incomes: 'Não desejo informar',
  net_equity: 'Não desejo informar',
  address: {
    city: '',
    state: '',
    number: '',
    street: '',
    zipcode: '',
    complement: '',
    neighborhood: '',
  },
}

export const initialValues = (type: 'individual' | 'legal_entity') => {
  return (
    {
      individual: {
        ...commonValues,
        birthdate: '',
        email: '',
        occupation: '',
        foreigner: {
          enabled: false,
          country: '',
        },
        pep: {
          enabled: false,
          relation: {
            enabled: false,
            degree: '',
          },
        },
      },
      legal_entity: {
        ...commonValues,
        foundation_date: '',
        type: '',
        activity: '',
        municipal_inscription: '',
        simples_nacional: '',
        partners: [],
        responsible: {
          cpf: '',
          name: '',
          email: '',
          address: {
            city: '',
            state: '',
            number: '',
            street: '',
            zipcode: '',
            complement: '',
            neighborhood: '',
          },
          foreigner: {
            enabled: false,
            country: '',
          },
          pep: {
            enabled: false,
            relationship_degree: '',
          },
        },
      },
    }[type] || commonValues
  )
}
